<template>
    <checker-detail-row>
        <div slot="left">Duration</div>
        <div slot="right">{{ duration | formattedHours }}</div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import { mapGetters } from 'vuex';

    export default {
        name: 'duration-row',

        components: { CheckerDetailRow },

        computed: {
            ...mapGetters('booking', [
                'duration',
            ]),
        },
    };
</script>
